import React from "react";
import { Box, Typography } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import Banner from "../../AdminDashboard/HomeScreenContent/Banner";

const AdvisorHomeBanner = () => {
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          px: 3,
          py: 2,
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
        }}
      >
        <ImageIcon sx={{ color: "#eef2f7", fontSize: 26 }} />
        <Box>
          <Typography sx={{ color: "#ffffff", fontWeight: 700, fontSize: 18, lineHeight: 1.2 }}>
            Home Banner
          </Typography>
          <Typography sx={{ color: "#b8d4c4", fontSize: 12 }}>
            Upload and manage app home screen banners
          </Typography>
        </Box>
      </Box>

      <Banner />
    </Box>
  );
};

export default AdvisorHomeBanner;
